import React, { useEffect } from "react";
import ScreenHeading from "../../utilities/ScreenHeading/ScreenHeading";
import ScrollService from "../../utilities/ScrollService";
import Animations from "../../utilities/Animations";
import "./AboutMe.css";

export default function AboutMe(props) {
  
  let fadeInScreenHandler = (screen) => {
    if (screen.fadeScreen !== props.id) return;
    Animations.animations.fadeInScreen(props.id);
  };

  const fadeInSubscription =
    ScrollService.currentScreenFadeIn.subscribe(fadeInScreenHandler);

  const SCREEN_CONSTSANTS = {
    description:
      "Hi, Everyone I am Maneka Singh persuing BTech in Computer Science from Jaypee Institute Of Information Technology, Noida. I have completed my senior high schooling from G.D Goenka Public School, Patna.I have a keen interest in Web-development and worked in some past projects earlier. I also do Graphic Designing, Competitive Coding, Freelancing, Android App Development and I am also a great ML & OpenSource Enthusiast. Currently I am more focused towards Competitive Coding and Open Source Contributions. I strongly beleive that hardwork and learning adds more value to one's personality than appearance.",
    highlights: {
      bullets: [
        "Full Stack Web and Mobile development",
        "Competitive Coder",
        "Codechef- 3☆(1604-Highest), Hackerrank - 5☆(C++ & C)",
        "Freelancer",
        "Graphic Designer",
        "ML & OpenSource Enthusiast",
      ],
      heading: "Here are a Few Highlights:",
    },
  };
  const renderHighlight = () => {
    return SCREEN_CONSTSANTS.highlights.bullets.map((value, i) => (
      <div className="highlight" key={i}>
        <div className="highlight-blob"></div>
        <span>{value}</span>
      </div>
    ));
  };

  return (
    <div className="about-me-container screen-container" id={props.id || ""}>
      <div className="about-me-parent">
        <ScreenHeading title={"About Me"} subHeading={"Why Choose Me?"} />
        <div className="about-me-card">
          <div className="about-me-profile"></div>
          <div className="about-me-details">
            <span className="about-me-description">
              {SCREEN_CONSTSANTS.description}
            </span>
            <div className="about-me-highlights">
              <div className="highlight-heading">
                <span>{SCREEN_CONSTSANTS.highlights.heading}</span>
              </div>
              {renderHighlight()}
            </div>
            <div className="about-me-options">
              <button className="btn primary-btn"> Hire Me </button>
              <a href="ehizcv.pdf" download="Ehiedu Ehizcv.pdf">
                <button className="btn highlighted-btn">Get Resume</button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
